declare var window: any;

export class DynamicEnvironment {
    public get webApiUrl() {
        return window.config.webApiUrl;
    }
    public get clientId() {
        return window.config.clientId;
    }
    public get webUrl() {
        return window.config.webUrl;
    }
    public get envName() {
        return window.config.envName;
    }
    public get pusher() {
        return window.config.pusher;
    }
    public get growlTimeout() {
        return window.config.growlTimeout;
    }
    public get gaTracking() {
        return window.config.gaTracking;
    }
    public get gaTrackingCode() {
        return window.config.gaTrackingCode;
    }
    public get cosmeticURLDefault() {
        return window.config.cosmeticURLDefault;
    }
    public get pusherChannelPrefix() {
        return window.config.pusherChannelPrefix;
    }
    public get pollingInterval() {
        return window.config.pollingInterval;
    }
    public get skipAPIVersioning() {
        return window.config.skipAPIVersioning;
    }
    public get Okta_CLIENT_ID() {
        return window.config.Okta_CLIENT_ID;
    }
    public get Okta_ISSUER() {
        return window.config.Okta_ISSUER;
    }
    public get Okta_LOGIN_REDIRECT_URI() {
        return window.config.Okta_LOGIN_REDIRECT_URI;
    }
    public get Okta_LOGOUT_REDIRECT_URI() {
        return window.config.Okta_LOGOUT_REDIRECT_URI;
    }
    public get Okta_TigerRiskIDP() {
        return window.config.Okta_TigerRiskIDP;
    }
    public get Okta_TigerRiskSwitchIDP() {
        return window.config.Okta_TigerRiskSwitchIDP;
    }
}